import { isCommentWriteUrl } from './utility/comment-write-url';
import { apiConstant } from './utility/constant/api-constant';
import { statusCode } from './utility/constant/config';

const SOA_NOT_EXISTS_TEXT = 'SoA table does not exist';
const ECB_NOT_EXISTS_TEXT = 'Eligibility criteria does not exist';

/** What the no-access dialog is opened with. */
export interface NoAccessDialogData {
    dialogContentText: string;
    dialogHeaderText: string;
    displayFor: 'access_denied';
    navigateBack: boolean;
    projectMetadata: unknown;
}

/** The side effects the response tap can cause, supplied by its registrar. */
export interface ResponseTapEffects {
    navigateNotFound(): void;
    notifyError(message: string): void;
    openNoAccessDialog(data: NoAccessDialogData): void;
}

/**
 * Handles an HTTP 200 response whose body says `is_success: false`.
 *
 * A missing table or a denied access opens the no-access dialog and returns;
 * a missing instance navigates to the not-found page. A comment write is
 * neither toasted nor thrown, in any branch. Any other refusal has its
 * message toasted, when there is one, and is then thrown.
 */
export function appResponseTap(res: any, effects: ResponseTapEffects): void {
    if (res?.status !== statusCode.ok || res.body?.is_success !== false) {
        return;
    }
    const message: string = res.body.message ?? '';
    const soaNotExists = message.includes(SOA_NOT_EXISTS_TEXT);
    const ecbNotExists = message.includes(ECB_NOT_EXISTS_TEXT);
    const isAccessDenied = message.includes('Access denied:');
    const isStudyInfoLookup = String(res.url ?? '').includes(
        apiConstant.fetchStudyInfoSIL
    );

    if (soaNotExists || ecbNotExists || isAccessDenied) {
        const navigateBack = soaNotExists || ecbNotExists;
        let dialogHeaderText = 'Access Denied';
        if (soaNotExists) {
            dialogHeaderText = SOA_NOT_EXISTS_TEXT;
        } else if (ecbNotExists) {
            dialogHeaderText = ECB_NOT_EXISTS_TEXT;
        }
        effects.openNoAccessDialog({
            dialogContentText: navigateBack
                ? 'The scenario has been retired and a new instance cannot be created.'
                : message,
            dialogHeaderText,
            displayFor: 'access_denied',
            navigateBack,
            projectMetadata: res.body.data?.project_metadata,
        });
        return;
    }

    const commentWrite = isCommentWriteUrl(res.url);
    if (isStudyInfoLookup) {
        return;
    }

    if (message.includes('Instance ID not found')) {
        effects.navigateNotFound();
    } else if (!commentWrite && message) {
        effects.notifyError(message);
    }
    if (!commentWrite) {
        throw new TypeError(message);
    }
}
